import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { database } from "../app-database";
import FormularioSeguridad from "../gnp-registro-seguridad/formulario-seguridad.cmpt";

const mapState = (state) => {
	return {
		preguntas1: state.catalogos.catalogoPregunta1,
		preguntas2: state.catalogos.catalogoPregunta2,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		llenarPreguntas: (cat1, cat2) => {
			dispatch({ "type": "CARGAR_CATALOGO_PREGUNTAS", catalogoPregunta1: cat1, catalogoPregunta2: cat2 });
		}
	};
};

const validate = values => {
	const errors = {};
	function checkMayus(str) {
		return str.toLowerCase() != str;
	}

	if (!values.password) {
		errors.password = "Campo requerido.";
	} else if (/\s+/.test(values.password)) {
		errors.password = "No se admiten espacios en blanco.";
	} else if (values.password.length <= 7) {
		errors.password = "Debe ser al menos de 8 posiciones.";
	} else if (values.password.toLowerCase().includes("gnp")) {
		errors.password = "No debe contener la palabra GNP.";
	} else
		if (isNaN(values.password) === false) {
			errors.password = "Debe incluir caracteres alfabéticos.";
		} else if (/[0-9]/.test(values.password) == false) {
			errors.password = "Debe contener al menos un carácter numérico.";
		} else if (/([\w])\1{2,}/.test(values.password)) {
			errors.password = "No debe contener más de dos caracteres de de forma consecutiva (222, eee).";
		} else if (checkMayus(values.password) == false) {
			errors.password = "Debe incluir al menos una mayúscula"
		} else {
			let ABC = "abcdefghijklmnopqrstuvwxyz", NUMEROS = "0123456789";
			for (var i = 0; i < values.password.length; i++) {
				var cadena = values.password.substr(i, 3).toLowerCase();
				if (cadena.length == 3 && (ABC.indexOf(cadena) >= 0 || NUMEROS.indexOf(cadena) >= 0)) {
					errors.password = "No debe contener más de dos caracteres de forma consecutiva (123, abc).";
					break;
				}
			}
		}

	if (!values.confpassword) {
		errors.confpassword = "Campo requerido.";
	} else if (values.confpassword != values.password) {
		errors.confpassword = "Tus contraseñas no coinciden. Favor de verificar.";
	}

	if (!values.pregunta1 || values.pregunta1 == 0) {
		errors.pregunta1 = "Campo requerido.";
	}

	if (!values.respuesta1) {
		errors.respuesta1 = "Campo requerido.";
	} else if (values.respuesta1 == values.respuesta2) {
		errors.respuesta1 = "Tus respuestas no deben ser iguales. Favor de verificar.";
	}

	if (!values.pregunta2 || values.pregunta2 == 0) {
		errors.pregunta2 = "Campo requerido.";
	}

	if (!values.respuesta2) {
		errors.respuesta2 = "Campo requerido.";
	} else if (values.respuesta1 == values.respuesta2) {
		errors.respuesta2 = "Tus respuestas no deben ser iguales. Favor de verificar.";
	}

	return errors;
};


class SeguridadForm extends React.Component {

	componentWillMount = () => {
		database.ref("preguntas").on("value", snapshot => {
			let data = snapshot.val();
			this.props.llenarPreguntas(data.pregunta1, data.pregunta2);
		});
	}

	handleChange = (sParam, e) => {
		this.setState({ [sParam]: e.target.value });
		this.validate(sParam, e.target.value);
	}

	toggle = (sParam) => {
		this.setState({ [sParam]: !this.state[sParam] });
	}

	handleSelect = (sParam, e) => {
		this.setState({ [sParam]: e });
	}

	state = {
		showPass: false,
		showConfPass: false,
		showResp1: false,
		showResp2: false,
		password: "",
		confPassword: "",
		respuesta1: "",
		respuesta2: "",
		pregunta1: 0,
		pregunta2: 0,
		validate: {
			password: false,
			confPassword: false,
			respuesta1: false,
			respuesta2: false
		}
	}
	render() {
		const { handleSubmit } = this.props;

		return (
			<form onSubmit={handleSubmit}>

				<FormularioSeguridad></FormularioSeguridad>

				<div className="modal fade" id="modal-contrasena" tabIndex="-1" role="dialog" aria-labelledby="modal-contrasenaLabel">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h4 className="modal-title" id="modal-contrasenaLabel">Para tu nueva contraseña contempla que:</h4>
							</div>
							<div className="modal-body">
								<ol>
									<li>Debe ser de al menos 8 posiciones, incluyendo caracteres alfanuméricos.</li>
									<li>No debe contener la palabra GNP.</li>
									<li>No debe contener más de dos caracteres iguales de forma consecutiva (p.e. 222, eee).</li>
									<li>No debe tener más de dos caracteres consecutivos numéricos o alfabéticos (p.e. 123, abc).</li>
									<li>Debe incluir al menos una letra mayúscula, una letra minúscula y un número.</li>

								</ol>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn orange-btn" data-dismiss="modal">Aceptar</button>
							</div>
						</div>
					</div>
				</div>

				<div className="modal fade" id="modal-preguntas" tabIndex="-1" role="dialog" aria-labelledby="modal-preguntasLabel">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h4 className="modal-title" id="modal-preguntasLabel">Importante</h4>
							</div>
							<div className="modal-body text-center">
								<p>Las preguntas secretas te ayudarán a desbloquear tu contraseña en caso de olvido y también se te solicitarán para autorizar algunas transacciones, podrás utilizarlas en la aplicación Soy Cliente GNP.</p>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn orange-btn" data-dismiss="modal">Aceptar</button>
							</div>
						</div>
					</div>
				</div>
			</form>
		);
	}
}

SeguridadForm = reduxForm({
	form: "datosSeguridad",
	validate
})(SeguridadForm);

export default connect(mapState, mapDispatch)(SeguridadForm);



// WEBPACK FOOTER //
// ./src/gnp-registro-familiar/seguridad.frm.js